export const BASE_URL = process.env.REACT_APP_API_ENDPOINT

export const OPEN_RESPONSE_MODAL_ACCOUNTING = 'OPEN_RESPONSE_MODAL_ACCOUNTING'
export const SET_KEYWORD_SEARCH_ACCOUNTING = 'SET_KEYWORD_SEARCH_ACCOUNTING'

export const SET_AP_FILTER = 'SET_AP_FILTER'
export const SET_AR_FILTER = 'SET_AR_FILTER'

export const ACCOUNTING_BILLING_LIST_REQUEST = 'ACCOUNTING_BILLING_LIST_REQUEST'
export const ACCOUNTING_BILLING_LIST_SUCCESS = 'ACCOUNTING_BILLING_LIST_SUCCESS'
export const ACCOUNTING_BILLING_LIST_FAILURE = 'ACCOUNTING_BILLING_LIST_FAILURE'

export const ACCOUNTING_BILLING_GET_REQUEST = 'ACCOUNTING_BILLING_GET_REQUEST'
export const ACCOUNTING_BILLING_GET_SUCCESS = 'ACCOUNTING_BILLING_GET_SUCCESS'
export const ACCOUNTING_BILLING_GET_FAILURE = 'ACCOUNTING_BILLING_GET_FAILURE'
export const ACCOUNTING_BILLING_GET_RESET = 'ACCOUNTING_BILLING_GET_RESET'

export const ACCOUNTING_BILLING_EDIT_REQUEST = 'ACCOUNTING_BILLING_EDIT_REQUEST'
export const ACCOUNTING_BILLING_EDIT_SUCCESS = 'ACCOUNTING_BILLING_EDIT_SUCCESS'
export const ACCOUNTING_BILLING_EDIT_FAILURE = 'ACCOUNTING_BILLING_EDIT_FAILURE'
export const ACCOUNTING_BILLING_EDIT_RESET = 'ACCOUNTING_BILLING_EDIT_RESET'

export const ACCOUNTING_BILLING_EXPORT_REQUEST = 'ACCOUNTING_BILLING_EXPORT_REQUEST'
export const ACCOUNTING_BILLING_EXPORT_SUCCESS = 'ACCOUNTING_BILLING_EXPORT_SUCCESS'
export const ACCOUNTING_BILLING_EXPORT_FAILURE = 'ACCOUNTING_BILLING_EXPORT_FAILURE'
export const ACCOUNTING_BILLING_EXPORT_RESET = 'ACCOUNTING_BILLING_EXPORT_RESET'

export const ACCOUNTING_PAYING_LIST_REQUEST = 'ACCOUNTING_PAYING_LIST_REQUEST'
export const ACCOUNTING_PAYING_LIST_SUCCESS = 'ACCOUNTING_PAYING_LIST_SUCCESS'
export const ACCOUNTING_PAYING_LIST_FAILURE = 'ACCOUNTING_PAYING_LIST_FAILURE'

export const ACCOUNTING_PAYING_GET_REQUEST = 'ACCOUNTING_PAYING_GET_REQUEST'
export const ACCOUNTING_PAYING_GET_SUCCESS = 'ACCOUNTING_PAYING_GET_SUCCESS'
export const ACCOUNTING_PAYING_GET_FAILURE = 'ACCOUNTING_PAYING_GET_FAILURE'
export const ACCOUNTING_PAYING_GET_RESET = 'ACCOUNTING_PAYING_GET_RESET'

export const ACCOUNTING_PAYING_EDIT_REQUEST = 'ACCOUNTING_PAYING_EDIT_REQUEST'
export const ACCOUNTING_PAYING_EDIT_SUCCESS = 'ACCOUNTING_PAYING_EDIT_SUCCESS'
export const ACCOUNTING_PAYING_EDIT_FAILURE = 'ACCOUNTING_PAYING_EDIT_FAILURE'
export const ACCOUNTING_PAYING_EDIT_RESET = 'ACCOUNTING_PAYING_EDIT_RESET'

export const ACCOUNTING_PAYING_EXPORT_REQUEST = 'ACCOUNTING_PAYING_EXPORT_REQUEST'
export const ACCOUNTING_PAYING_EXPORT_SUCCESS = 'ACCOUNTING_PAYING_EXPORT_SUCCESS'
export const ACCOUNTING_PAYING_EXPORT_FAILURE = 'ACCOUNTING_PAYING_EXPORT_FAILURE'
export const ACCOUNTING_PAYING_EXPORT_RESET = 'ACCOUNTING_PAYING_EXPORT_RESET'



// WEBPACK FOOTER //
// ./src/actions/accounting-dashboard/types.js